/* eslint no-param-reassign: 0 */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentSelectedMultimediaInput: {},
  locationValues: {},
  barcodeValues: {},
  imageInputValues: {},
  imagesToSubmit: {},
  imageDraftValues: {},
  isOpen: true,
};

const multimediaSlice = createSlice({
  name: 'multimedia',
  initialState,
  reducers: {
    resetMultimediaSliceState: () => initialState,
    setCurrentSelectedMultimediaInput(state, action) {
      const { payload } = action;

      if (!payload.element) {
        state.currentSelectedMultimediaInput = {};
      } else {
        state.currentSelectedMultimediaInput = action.payload;
      }
    },
    addLocationValue(state, action) {
      const { key, value } = action.payload;
      state.locationValues[key] = value;
    },
    removeLocationValue(state, action) {
      delete state.locationValues[action.payload];
    },
    addBarcodeValue(state, action) {
      const { key, value } = action.payload;
      state.barcodeValues[key] = value;
    },
    addImageInputValue(state, action) {
      const { key, value } = action.payload;
      state.imageInputValues[key] = value;
    },
    addImageToSubmit(state, action) {
      const { key, value } = action.payload;
      state.imagesToSubmit[key] = value;
    },
    removeImageToSubmit(state, action) {
      delete state.imagesToSubmit[action.payload];
    },
    addImageDraftValues(state, action) {
      state.imageDraftValues = action.payload.imageDrafts;
    },
    removeImageDraftValue(state, action) {
      delete state.imageDraftValues[action.payload];
    },
    setMultimediaPosition(state, action) {
      state.isOpen = action.payload;
    },
  },
});

export const {
  resetMultimediaSliceState,
  setCurrentSelectedMultimediaInput,
  addLocationValue,
  removeLocationValue,
  addBarcodeValue,
  addImageInputValue,
  addImageToSubmit,
  removeImageToSubmit,
  setMultimediaPosition,
  addImageDraftValues,
  removeImageDraftValue,
} = multimediaSlice.actions;
export default multimediaSlice.reducer;
